// ─── Insurance-specific SUI Hooks ────────────────────────────────────────
import { useSuiClientQuery, useCurrentAccount } from '@mysten/dapp-kit';
import { AGU_TOKEN_TYPE, AGU_DECIMALS, OBJECTS } from './constants';

export function useAGUBalance() {
  const account = useCurrentAccount();
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getBalance',
    { owner: account?.address ?? '', coinType: AGU_TOKEN_TYPE },
    { enabled: !!account?.address },
  );
  const raw = BigInt((data as any)?.totalBalance ?? '0');
  const balance = Number(raw) / 10 ** AGU_DECIMALS;
  return { balance, rawBalance: raw, isLoading, error, refetch, address: account?.address };
}

export function useInsurancePool() {
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getObject',
    { id: OBJECTS.insurancePool, options: { showContent: true } },
  );
  let info = { poolBalance: '0', totalPremiums: '0', totalClaims: '0', activePolicies: 0 };
  const obj = data as any;
  if (obj?.data?.content?.dataType === 'moveObject') {
    const f = obj.data.content.fields;
    if (f) {
      info = {
        poolBalance: f.pool_balance || f.balance || '0',
        totalPremiums: f.total_premiums || '0',
        totalClaims: f.total_claims || '0',
        activePolicies: Number(f.active_policies || f.policy_count || 0),
      };
    }
  }
  return { info, isLoading, error, refetch };
}

export function useSettlementTreasury() {
  const { data, isLoading, error, refetch } = useSuiClientQuery(
    'getObject',
    { id: OBJECTS.settlementTreasury, options: { showContent: true } },
  );
  let info = { totalLocked: '0', totalSettled: '0', escrowCount: 0 };
  const obj = data as any;
  if (obj?.data?.content?.dataType === 'moveObject') {
    const f = obj.data.content.fields;
    if (f) {
      info = {
        totalLocked: f.total_locked || '0',
        totalSettled: f.total_settled || '0',
        escrowCount: Number(f.escrow_count || 0),
      };
    }
  }
  return { info, isLoading, error, refetch };
}
